import React, { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchGameDetail } from '../redux/actions/gameDetailActions';
import '../styles/GameDetailPage.css';

const GameDetailPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // 从 location.state 中获取游戏标题
  const gameTitle = location.state?.gameTitle || 'Loading...';

  const { gameDetail, loading, error } = useSelector(state => state.gameDetail);
  const formattedTitle = gameTitle
  .toLowerCase() // 转小写
  .replace(/\./g, '-') // 将点号替换为连字符
  .replace(/[^a-z0-9\s-]/g, '') // 移除特殊字符
  .trim() // 移除首尾空格
  .replace(/\./g, '') // 移除所有点号
  .replace(/\s+/g, '-') // 将空格替换为连字符
  .replace(/-+/g, '-'); // 替换多个连续的连字符为一个

  // 构建 iframe URL
  const iframeUrl = `https://games.crazygames.com/en_US/${formattedTitle}/index.html`;
  useEffect(() => {
    if (id) {
      dispatch(fetchGameDetail(id));
    }
  }, [dispatch, id]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return <div className="loading">Loading game details...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="game-detail-page">
      <button onClick={handleBack} className="back-button">
        ← Back
      </button>
      
      <div className="game-detail-content">
        <h1 className="game-title">{gameTitle}</h1>
         {/* 游戏 iframe 容器 */}
         <div className="game-frame-container">
          <iframe
            src={iframeUrl}
            title={gameTitle}
            className="game-frame"
            allowFullScreen
            scrolling="no"
            frameBorder="0"
            allow="autoplay; fullscreen; focus-without-user-activation *;"
            sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-scripts allow-same-origin allow-downloads"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default GameDetailPage;